<div class="feature-selection">
  <div class="current-product">
    <span class="product-name">
      {{ product.name }}
    </span>
    <div class="spacer"></div>
  </div>
  <hr />

  <div class="flex-container">
    <mat-card class="selected-feature">
      <mat-card-header>
      </mat-card-header>

      <mat-card-content>
        <div class="feature-image">
          <img *ngIf="selectedFeature.image && selectedFeature.image.mediumURL"
              src="{{selectedFeature.image.mediumURL}}">
        </div>

        <div class="feature-description"
             [innerHTML]="selectedFeature.description">
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="feature-group">
      <mat-card-header>
        <mat-card-title>
          <span class="product-name">
            {{ product.name }}
          </span>

          <span class="product-price">
            <price-display [price]="getCurrentPriceConfig(product.price, product.quantity)"
                           [quantity]="product.quantity"></price-display>
          </span>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-radio-group class="feature-selection-radio-group"
                  [value]="featureGroup.selectedFeature"
                  (change)="setSelectedFeature($event.value)">
          <mat-radio-button #featureRadioButton
              *ngFor="let feature of features; trackBy: trackById"
              [value]="feature.id"
              [disabled]="!feature.inStock">
            <span class="radio-name-price"
                [ngClass]="{'disabled': featureRadioButton.disabled}">
              <span class="name">{{ feature.name }}</span>
              <div class="promotion-sign" *ngIf="feature.isPromoted">
                <img src="/assets/img/promotion_sign.svg" />
              </div>
              <span class="price">
                <price-display
                    [price]="getCurrentPriceConfig(feature.price, product.quantity)"
                    [display]="'hideOnZeroValue'"
                    [showAsAddition]="true"
                    [quantity]="product.quantity"
                ></price-display>
              </span>
            </span>
          </mat-radio-button>
        </mat-radio-group>
      </mat-card-content>
      <mat-card-footer>
        {{ 'i18n.price.total' | translate }}:
        <price-display
          [price]="priceCalculationService.productTotal"
          [display]="'reducedAmountOnly'"
        ></price-display>
      </mat-card-footer>
    </mat-card>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/feature-selection/feature-selection.component.html